module.exports = __webpack_public_path__ + "assets/img/bind7.ccff97fd.png";